<script setup>
import { computed } from 'vue';
import { isWindowsPlatform, flagIconClass } from 'shared/helpers/flagEmoji';

const props = defineProps({
  // Native flag emoji (e.g. 🇧🇷). Used as-is on platforms with emoji fonts.
  emoji: {
    type: String,
    default: '',
  },
  // ISO country code (e.g. BR). Used to render a flag-icons glyph on Windows,
  // which no longer ships color flag emojis natively.
  code: {
    type: String,
    default: '',
  },
});

const isWindows = isWindowsPlatform();

const flagClass = computed(() => flagIconClass(props.code));

const useIcon = computed(() => isWindows && Boolean(props.code));
</script>

<template>
  <span
    v-if="useIcon"
    :class="flagClass"
    :title="code.toUpperCase()"
    :aria-label="code.toUpperCase()"
  />
  <span v-else>{{ emoji }}</span>
</template>

<style>
@import 'flag-icons/css/flag-icons.min.css';

/* Squared (fis) flag rendered as a circle — kept in sync with the
   `.flag-emoji` rule in dashboard/assets/scss/_layout.scss so the icon looks
   the same in the widget/signup bundles, which don't load that file. */
.flag-emoji {
  margin-inline: 2px;
  vertical-align: -0.1em;
  background-size: cover;
  border-radius: 20%;
}
</style>
